let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Dhr1")).then(() => parcelRequire('dauBg'));